import "ngstorage";
import angular from "angular";

export default class JobService {
  constructor($http, $localStorage, $state, $q, SecurityService, AuthService, EnvService, $rootScope, $timeout, $interval, $location) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$env = EnvService;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.$interval = $interval;
    this.$location = $location;
    this.PubNub = null;
    this.unsortedChannelList = [];
    this.nestedChannelList = [];
    this.arrayOfImageUrlsForGallery = [];
    this.controlChannelVal = null;

    // TODO: DELETE THIS CODE - eke
    // let data = {
    //     "id": 4027943,
    //     "jobbler": 249259,
    //     "confirmationNote": "shift.note",
    //     "confirmationResponse" : true,
    //     "confirmationSource" : "mobile"
    // }
    //
    // let req = {
    //     method: "POST",
    //     data: data,
    //     headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
    //     },
    //     url: this.$env.getAPIEndPoint() + "jbl/v1/shifts/confirmation?format=json&conf=web",
    // };
    //
    // this.$http(req).then((data) => {
    //     console.log("CONSIMRE SPOND", data);
    // })
  }

  getPlaceRef(data) {
    var _this = this;

    let req = {method: "GET", data: {}};

    let zipcode = null;
    if (data.zipcode) {
      zipcode = data.zipcode;
    } else {
      zipcode = data;
    }

    if (!_this.$localStorage.logged_user) {
      req.url = _this.$env.getAPIEndPoint() + "public/places?format=json&conf=web&type=Zipcode&zipCode=" + zipcode + "&countryIsoCode=US&max=1";
      req.headers = {"Content-Type": "application/json"};
    } else {
      req.url = _this.$env.getAPIEndPoint() + "jbl/v1/places?format=json&conf=web&type=Zipcode&zipCode=" + zipcode + "&countryIsoCode=US&max=1";
      req.headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      };
    }
    return _this.$http(req);
  }

  getJobsPOST(data, max) {
    if (!data.geoFenceRadius) {
      data.geoFenceRadius = 25;
    }

    if (!data.sort || _.isEmpty(data.sort)) {
      data.sort = undefined;
    }

    if (!data.offset) {
      data.offset = 0;
    }

    if (!data.company) {
      data.company = null;
    }

    if (!data.search) {
      data.search = null;
    }

    max = max || data.max || 10;

    console.log("whats in the job search data object");
    console.dir(data);

    //https://jobs.alpha.jobble.it/api/v1/jobbles?User-Agent=iPhone&zipcode=02111&geoFenceRadius=50&offset=0&limit=10

    let url =
      this.$env.getJobsAPIEndPoint() +
      "jobbles?geoFenceRadius=" +
      data.geoFenceRadius +
      "&offset=" +
      data.offset +
      "&limit=" +
      max +
      "&zipcode=" +
      data.zipcode;

    if (data.company) {
      url = url + "&company=" + data.company;
    }

    if (data.search) {
      let searchDelim = data.search.replace(",", "%7C%7C");

      url = url + "&search=" + searchDelim;
    }

    if (data.sort) {
      url = url + "&sort=" + data.sort.name + "&direction=" + data.sort.value;
    }

    let req = {method: "GET"};
    req.url = url;

    /*

		let req = { method: 'POST' };

		req.data = {
				"queryPref": {
					"name": "querypreference",
					"jobbleTypes": data.jobbleTypes,
					"eventTypes": [],
					"companies": [],
					"company": data.company,
					"search": data.search,
					"geoFenceRadius": data.geoFenceRadius,
					"geoFenceRef":
						{
							"lat": data.lat,
							"lng": data.lng
						},
					"placeRef": data.placeRef,
				}
			}

		req.url = this.$env.getAPIEndPoint() + "jbl/v1/jobbles/suggestionFilter?format=json&max=" + max + "&offset=" + data.offset + (data.sort ? ("&sort=" + data.sort.name + "&order=" + data.sort.value) : "") + "&conf=web&isPublished=true&isPayed=false&excludeChainAndPoolDupe=true&excludeEndTimePassed=true&isClosed=false&isCompleted=false&isCancelled=false&diffUTC=-4&fields=id,dateCreated,isFillInPost,isSourcingPost,pickupLocation,dressCode,jobbleType.picture1,isClickcastPost,dropoffLocation,pickupTime,dropoffTime,partnerPostContent,description,startTimeFormattedLoc,endTimeFormattedLoc,shifts.id,shifts.timeInterval.startTime,shifts.timeInterval.endTime,numberOfShifts,jobbleType.name,jobbleType.id,subEvent.event.numberOfOpenings,subEvent.event.company.name,subEvent.event.name,subEvent.event.company.id,subEvent.event.company.autoAccept,subEvent.contactInfo.place.timeZoneId,subEvent.contactInfo.streetLine1,subEvent.contactInfo.streetLine2,subEvent.contactInfo.city,subEvent.contactInfo.state,subEvent.contactInfo.zipCode,jobblerRate,numberOfOpenings,inCircle,forCircleOnly,isSourcingPost,applyByTime,name,payPerHour,subEvent.event.company.companyLogoUriFree";
		*/

    req.headers = {
      "Content-Type": "application/json",
    };

    if (this.$localStorage.logged_user) {
      req.headers["Authorization"] = "Bearer " + this.$localStorage.logged_user.access_token;
    }

    console.log("what is the request");
    console.dir(req);

    return this.$http(req);
  }

  getRequirements(data) {
    var _this = this;

    var req = {
      method: "GET",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/event/" + data.eventId + "/requirement?format=json",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(req);
  }

  getQuestions(eventId) {
    var _this = this;

    var req = {
      method: "GET",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/events/" +
        eventId +
        "?format=json&fields=id,surveyQuestions.id,surveyQuestions.name,surveyQuestions.question,surveyQuestions.questionType,surveyQuestions.displayOrder",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(req);
  }

  getJobs(data) {
    var _this = this;
    var req = {
      method: "GET",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/jobbles?format=json&max=10&offset=0&sort=dateCreated&order=desc&conf=web&isPublished=true&isPayed=false&excludeChainAndPoolDupe=true&excludeEndTimePassed=true&isClosed=false&isCompleted=false&isCancelled=false&diffUTC=-4&fields=id,description,startTimeFormattedLoc,endTimeFormattedLoc,numberOfShifts,jobbleType.name,subEvent.event.company.fileCOMPANY_LOGO1IMG_160x160,subEvent.event.company.name,subEvent.event.name,subEvent.event.orderNumber,subEvent.contactInfo.place.timeZoneId,subEvent.contactInfo.streetLine1,subEvent.contactInfo.streetLine2,subEvent.contactInfo.city,subEvent.contactInfo.state,subEvent.contactInfo.zipCode,jobblerRate,numberOfOpenings,inCircle,forCircleOnly,isSourcingPost,applyByTime,name,subEvent.event.company.companyLogoOtherUri,payPerHour",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      },
      data: {},
    };
    return _this.$http(req);
  }

  /*
	"jobbleId": 48348648,
	"jobbler": 3934,
    "confirmationResponse": false,
    "confirmationSource": "sms/John Smith - 123",
    "confirmationNote": "Nothing 123"
    */

  updateShiftWithUnConfirmationData(shift) {
    var _this = this;

    console.log("updateShiftWithConfirmationData");
    console.dir(shift);

    let data = {};

    data = {
      id: shift.id,
      jobbler: shift.userId,
      confirmationResponse: false,
      confirmationSource: _this.$localStorage.logged_user.username,
      confirmationNote: shift.note,
    };
    /*
		if(shift.confirmationResponse === true && shift.confirmationSource === "mobile"){

			console.log("here 1");
			data = {
				"id": shift.id,
				"jobbler": shift.userId,
				"confirmationNote": shift.note,
				"confirmationResponse" : true,
				"confirmationSource" : "mobile"
			}

		}else{

			console.log("here 2");
			data = {
					"id": shift.id,
					"jobbler": shift.userId,
					"confirmationResponse": true,
					"confirmationSource": _this.$localStorage.logged_user.username,
					"confirmationNote": shift.note
				}

		}
		*/

    let req = {
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/confirmation?format=json&conf=web",
    };

    console.log("what is the request");
    console.dir(req);

    return _this.$http(req);
  }

  updateShiftWithConfirmationData(shift) {
    var _this = this;

    let data = {};

    if (shift.confirmationResponse === true && shift.confirmationSource === "mobile") {
      data = {
        id: shift.id,
        jobbler: shift.userId,
        confirmationNote: shift.note,
        confirmationResponse: true,
        confirmationSource: "mobile",
      };
    } else {
      data = {
        id: shift.id,
        jobbler: shift.userId,
        confirmationResponse: true,
        confirmationSource: _this.$localStorage.logged_user.username,
        confirmationNote: shift.note,
      };
    }

    let req = {
      method: "POST",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/confirmation?format=json&conf=web",
    };

    return _this.$http(req);
  }

  getShift(id) {
    var _this = this;

    console.log("getShift");
    console.dir(id);

    var req = {
      method: "GET",
      data: {},
    };

    req.url =
      _this.$env.getAPIEndPoint() +
      "jbl/v1/shifts/" +
      id +
      "?format=json&fields=id,timeInterval.startTime,timeInterval.endTime,contactInfo.streetLine1,contactInfo.state,contactInfo.city,contactInfo.zipCode,contactInfo.place.timeZoneId,confirmationSource,confirmationResponse,confirmationNote,confirmationDateTime";
    req.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
    };

    return _this.$http(req);
  }

  getJobbleWithShifts(id) {
    var _this = this;

    console.log("getJobbleWithShifts");
    console.dir(id);

    var req = {
      method: "GET",
      data: {},
    };

    req.url =
      _this.$env.getAPIEndPoint() +
      "jbl/v1/jobbles/" +
      id +
      "?format=json&fields=id,shifts.id,shifts.timeInterval.startTime,shifts.timeInterval.endTime,shifts.contactInfo.streetLine1,shifts.contactInfo.state,shifts.contactInfo.city,shifts.contactInfo.zipCode,shifts.contactInfo.place.timeZoneId,shifts.confirmationSource,shifts.confirmationResponse,shifts.confirmationNote,shifts.confirmationDateTime";
    req.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
    };

    return _this.$http(req);
  }

  getJob(id) {
    var _this = this;

    var req = {
      method: "GET",
      data: {},
    };

    console.log("getJob");
    console.dir(_this.$localStorage.logged_user);

    if (!_this.$localStorage.logged_user) {
      console.log("getJob 2");
      req.url =
        _this.$env.getAPIEndPoint() +
        "public/jobbles/" +
        id +
        "?format=json&excludeChainAndPoolDupe=true&excludeEndTimePassed=true&isClosed=false&isCompleted=false&isCancelled=false&diffUTC=-4&fields=id,partnerPostContent,description,pickupLocation,dressCode,dropoffLocation,pickupAddress,dropoffAddress,pickupTime,dropoffTime,deliveryContactInfo,pickupContactInfo,dropoffContactInfo,startTimeFormattedLoc,endTimeFormattedLoc,numberOfShifts,jobbleType.id,jobbleType.name,subEvent.event.orderNumber,subEvent.event.numberOfOpenings,,subEvent.event.company.name,subEvent.event.name,subEvent.event.id,subEvent.contactInfo.streetLine1,subEvent.contactInfo.streetLine2,subEvent.contactInfo.city,subEvent.contactInfo.state,subEvent.contactInfo.zipCode,subEvent.contactInfo.place.timeZoneId,jobblerRate,numberOfOpenings,inCircle,forCircleOnly,isSourcingPost,applyByTime,name,payPerHour,shifts.padding,shifts.description,shifts.location,shifts.id,shifts.timeInterval.startTime,shifts.overnight,shifts.unpaidBreak,shifts.timeInterval.endTime,shifts.contactInfo.id,shifts.contactInfo.streetLine1,shifts.contactInfo.place.timeZoneId,shifts.contactInfo.city,shifts.contactInfo.state,shifts.contactInfo.zipCode,jobbleType.picture1,subEvent.event.company.companyLogoUriFree";
      req.headers = {"Content-Type": "application/json"};
    } else {
      console.log("getJob 3");

      req.url =
        _this.$env.getAPIEndPoint() +
        "jbl/v1/jobbles/" +
        id +
        "?format=json&excludeChainAndPoolDupe=true&excludeEndTimePassed=true&isClosed=false&isCompleted=false&isCancelled=false&diffUTC=-4&fields=id,applicationStatus,partnerPostContent,description,pickupLocation,dressCode,dropoffLocation,pickupAddress,dropoffAddress,pickupTime,dropoffTime,deliveryContactInfo,pickupContactInfo,dropoffContactInfo,startTimeFormattedLoc,endTimeFormattedLoc,numberOfShifts,jobbleType.id,jobbleType.name,subEvent.event.numberOfOpenings,subEvent.event.company.name,subEvent.event.name,subEvent.event.id,subEvent.event.orderNumber,subEvent.contactInfo.streetLine1,subEvent.contactInfo.streetLine2,subEvent.contactInfo.city,subEvent.contactInfo.state,subEvent.contactInfo.zipCode,subEvent.contactInfo.place.timeZoneId,jobblerRate,numberOfOpenings,inCircle,forCircleOnly,isSourcingPost,applyByTime,name,payPerHour,shifts.id,shifts.timeInterval.startTime,shifts.padding,shifts.description,shifts.location,shifts.unpaidBreak,shifts.overnight,shifts.timeInterval.endTime,shifts.contactInfo.id,shifts.contactInfo.streetLine1,shifts.contactInfo.place.timeZoneId,shifts.contactInfo.city,shifts.contactInfo.state,shifts.contactInfo.zipCode,jobbleType.picture1,subEvent.event.company.companyLogoUriFree";

      //req.url = _this.$env.getAPIEndPoint() + "jbl/v1/jobbles-details/" + id;

      req.headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
      };
    }

    return _this.$http(req);
  }

  getJobCompanyDesc(id) {
    let req = {
      method: "GET",
      data: {},
    };

    req.url =
      this.$env.getAPIEndPoint() +
      "public/jobbles/" +
      id +
      "?format=json&excludeChainAndPoolDupe=true&excludeEndTimePassed=true&isClosed=false&isCompleted=false&isCancelled=false&diffUTC=-4&fields=id,description,subEvent.event.company.description,subEvent.event.company.name,subEvent.event.company.fileCOMPANY_LOGO1IMG_160x160";
    req.headers = {"Content-Type": "application/json"};

    return this.$http(req);
  }

  getApplyTimeFrame(jobble) {
    var _this = this;
    let applyTimeFrame = "";
    if (jobble.endTimeFormattedLoc) {
      let start = new Date(jobble.endTimeFormattedLoc);
      let now = new Date();
      let diff = start - now;

      let diffInDays = diff / 1000 / 3600 / 24;
      let daysLeft = Math.floor(diffInDays);
      let remainderHours = Math.floor((diffInDays % 1) * 24);
      if (diff > 0) {
        if (daysLeft == 0) {
          applyTimeFrame = remainderHours + " hours left to apply";
        } else {
          applyTimeFrame = daysLeft + " days, " + remainderHours + " hours left to apply";
        }
      } else {
        daysLeft = daysLeft * -1;
        remainderHours = remainderHours * -1;
        if (daysLeft == 0) {
          applyTimeFrame = "Was " + remainderHours + " hours ago";
        } else {
          applyTimeFrame = "Was " + daysLeft + " days, " + remainderHours + " hours ago";
        }
      }
    }

    return applyTimeFrame;
  }

  getJobbleTimeFrameWithTimeZoneForBoard(job) {
    let ret = "";
    let time_object = {};

    let timeZone = null;

    if (job.contactInfo) {
      timeZone = job.contactInfo.place.timeZoneId;
    } else {
      timeZone = job.subEvent.contactInfo.place.timeZoneId;
    }

    let start;
    let end;

    if (timeZone === "Pacific/Honolulu" || timeZone === "America/Anchorage") {
      start = new Date(job.startTime);
      end = new Date(job.endTime);
    } else {
      start = new Date(job.startTimeFormattedLoc);
      end = new Date(job.endTimeFormattedLoc);
    }

    let startMoment = moment(start);
    let endMoment = moment(end);

    let diff = endMoment.diff(startMoment, "hours");
    let same_day = false;
    let startDay = startMoment.tz(timeZone).format("DD");
    let endDay = endMoment.tz(timeZone).format("DD");

    if (startDay === endDay) {
      same_day = true;
    }

    if (diff > 24 || same_day === false) {
      time_object.startTime = startMoment.tz(timeZone).format("MMM DD");
      time_object.endTime = endMoment.tz(timeZone).format("MMM DD");
      ret = time_object.startTime + " - " + time_object.endTime;
    } else {
      time_object.startTime = startMoment.tz(timeZone).format("MMM DD");
      ret = time_object.startTime; //+ ' - ' + time_object.endTime;
    }

    return ret;
  }

  getJobbleFullTimeFrameWithTimeZoneForBoard(job) {
    let ret = "";
    let time = "";
    let duration = "";
    let rawDuration = 0;

    let time_object = {};
    let start = new Date(job.startTimeFormattedLoc);
    let end = new Date(job.endTimeFormattedLoc);

    let startMoment = moment(start);
    let endMoment = moment(end);

    let timeZone = null;

    if (job.contactInfo) {
      timeZone = job.contactInfo.place.timeZoneId;
    } else {
      timeZone = job.subEvent.contactInfo.place.timeZoneId;
    }

    let diff = endMoment.diff(startMoment, "hours");
    let same_day = false;
    let startDay = startMoment.tz(timeZone).format("DD");
    let endDay = endMoment.tz(timeZone).format("DD");

    if (startDay === endDay) {
      same_day = true;
    }

    if (diff > 24 || same_day === false) {
      time_object.startTime = startMoment.tz(timeZone).format("ddd, MMM DD h:mmA");
      time_object.endTime = endMoment.tz(timeZone).format("h:mmA");
      ret = time_object.startTime + " - " + time_object.endTime;

      time = `${startMoment.tz(timeZone).format("h:mmA")} - ${endMoment.tz(timeZone).format("h:mmA")}`;

      const diffTime = endMoment.tz(timeZone).diff(startMoment.tz(timeZone));
      const durTime = moment.duration(diffTime);

      const durHours = durTime.hours();
      const durMin = durTime.minutes();

      duration = `${durHours ? durHours + " HR" : ""}${durHours > 1 ? "S" : ""}${durMin && durMin ? " " : ""}${durMin ? durMin + "MIN" : ""}`;
    } else {
      time_object.startTime = startMoment.tz(timeZone).format("ddd, MMM DD h:mmA");
      ret = time_object.startTime;

      time = `${startMoment.tz(timeZone).format("h:mmA")} - ${endMoment.tz(timeZone).format("h:mmA")}`;

      const diffTime = endMoment.tz(timeZone).diff(startMoment.tz(timeZone));
      const durTime = moment.duration(diffTime);

      const durHours = durTime.hours();
      const durMin = durTime.minutes();

      duration = `${durHours ? durHours + " HR" : ""}${durHours > 1 ? "S" : ""}${durMin && durMin ? " " : ""}${durMin ? durMin + "MIN" : ""}`;
      rawDuration = durHours + durMin / 60;
    }

    return {
      date: ret,
      time,
      duration,
      rawDuration,
    };
  }

  getJobbleTimeFrameWithTimeZone(timeInterval, timeZoneId) {
    var _this = this;

    console.log("getJobbleTimeFrameWithTimeZonegetJobbleTimeFrameWithTimeZonegetJobbleTimeFrameWithTimeZonegetJobbleTimeFrameWithTimeZone");
    console.dir(timeInterval);
    let ret = "";
    let time_object = {};
    let start = new Date(timeInterval.startTime);
    let end = new Date(timeInterval.endTime);
    time_object.startTime = moment(start).tz(timeZoneId).format("MMM DD, hh:mm A");
    time_object.endTime = moment(end).tz(timeZoneId).format("hh:mm A");
    ret = time_object.startTime + " - " + time_object.endTime;
    return ret;
  }

  getJobbleTimeFrame(jobble, shift) {
    console.log("get jobble time frame");
    console.dir(jobble);
    console.dir(shift);

    let timeFrame = "";

    if (jobble.startTime) {
      let start = new Date(jobble.startTime);

      //console.log("this should be seatle time");
      //console.dir(moment(start).tz(shift.contactInfo.place.timeZoneId).format('YYYY-MM-DD HH:mm'));

      timeFrame = start.toLocaleString("en-us", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
      if (jobble.endTime) {
        let end = new Date(jobble.endTime);
        timeFrame += " - ";

        let isSameDay = start.getDate() == end.getDate() && start.getMonth() == end.getMonth() && start.getFullYear() == end.getFullYear();

        if (isSameDay) {
          timeFrame += end.toLocaleString("en-us", {
            hour: "numeric",
            minute: "numeric",
          });
        } else {
          timeFrame += end.toLocaleString("en-us", {
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          });
        }
      }
    } else {
      if (jobble.startTimeFormattedLoc) {
        let start = new Date(jobble.startTimeFormattedLoc);
        timeFrame = start.toLocaleString("en-us", {
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        });
        if (jobble.endTimeFormattedLoc) {
          let end = new Date(jobble.endTimeFormattedLoc);
          timeFrame += " - ";

          let isSameDay = start.getDate() == end.getDate() && start.getMonth() == end.getMonth() && start.getFullYear() == end.getFullYear();

          if (isSameDay) {
            timeFrame += end.toLocaleString("en-us", {
              hour: "numeric",
              minute: "numeric",
            });
          } else {
            timeFrame += end.toLocaleString("en-us", {
              month: "short",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
            });
          }
        }
      }
    }
    return timeFrame;
  }

  getSurveyQuestions(id, user) {
    var _this = this;

    console.log("what is  _this.$localStorage");
    console.dir(_this.$localStorage);

    if (user) {
      _this.$localStorage.logged_user = user;
    }

    let req = {
      method: "GET",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/jobbles/" +
        id +
        "?format=json&fields=id,subEvent.event.surveyQuestions.id,subEvent.event.surveyQuestions.name,subEvent.event.surveyQuestions.question,subEvent.event.surveyQuestions.displayOrder",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
      },
      data: {},
    };

    return _this.$http(req);
  }

  applyToJob(questions, id, user_not_verified, user) {
    var _this = this;

    _this.$localStorage.logged_user = user;

    let array = [];
    let application = {spiel: "I am a good worker."};
    let not_verified = false;

    if (user_not_verified) {
      not_verified = true;
    }

    application.surveyResponses = [];

    try {
      if (questions[0].isStandard) {
        console.log("we have broken questions");
      } else {
        questions.forEach(function (question) {
          let object = {};

          object.response = "I am a good fit.";
          object.surveyQuestion = question.id;

          application.surveyResponses.push(object);
        });
      }
    } finally {
      let req = {
        method: "POST",
        data: {
          application: application,
          verified: not_verified,
        },
        url:
          _this.$env.getAPIEndPoint() +
          "jbl/v1/users/" +
          _this.$localStorage.logged_user.id +
          "/jobbles/" +
          id +
          "/apply?format=json&conf=web&fields=id",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + _this.$localStorage.logged_user.access_token,
        },
      };

      return _this.$http(req);
    }
  }

  canUserApplyToShiftBasedJobs() {
    console.log("Checking is user is validated");

    const req = {
      method: "GET",
      url: this.$env.getAPIEndPoint() + "jbl/v1/validate?format=json&conf=web",
      headers: {
        Authorization: "Bearer " + (this.$localStorage.logged_user ? this.$localStorage.logged_user.access_token : ""),
      },
      data: {},
    };

    return this.$http(req);
  }

  organizeTypes(jobble_type_parents, jobble_types) {
    var _this = this;
    let events_array = [];
    let industrial_array = [];
    let rh_array = [];
    let retail_array = [];
    let trans_array = [];
    let other_array = [];
    let categories = {
      events: null,
      light_industrial: null,
      restaurant: null,
      retail: null,
      transportation: null,
      other: null,
    };
    try {
      jobble_types.forEach(function (type, i) {
        let name = type.name;
        if (name === "Promotional Model") {
          events_array.push(type);
        } else if (name === "Brand Ambassador") {
          events_array.push(type);
        } else if (name === "Audio/Video Support") {
          events_array.push(type);
        } else if (name === "College Ambassador") {
          events_array.push(type);
        } else if (name === "Demo Specialist") {
          events_array.push(type);
        } else if (name === "Event Staff") {
          events_array.push(type);
        } else if (name === "Field Sales") {
          events_array.push(type);
        } else if (name === "Focus Group Participant") {
          events_array.push(type);
        } else if (name === "Greeter") {
          events_array.push(type);
          rh_array.push(type);
          retail_array.push(type);
        } else if (name === "Hair/Makeup Artist") {
          events_array.push(type);
        } else if (name === "Merchandising") {
          events_array.push(type);
          retail_array.push(type);
        } else if (name === "Nightlife Promotor") {
          events_array.push(type);
        } else if (name === "Parking Attendant") {
          events_array.push(type);
          rh_array.push(type);
          other_array.push(type);
        } else if (name === "Photographer") {
          events_array.push(type);
        } else if (name === "Product Demonstrator") {
          events_array.push(type);
        } else if (name === "Product Sampler") {
          events_array.push(type);
        } else if (name === "Referee") {
          events_array.push(type);
        } else if (name === "Registration") {
          events_array.push(type);
        } else if (name === "Setup and Breakdown Staff") {
          events_array.push(type);
        } else if (name === "Street Teamer") {
          events_array.push(type);
        } else if (name === "Surveyor") {
          events_array.push(type);
        } else if (name === "Tradeshow Staff") {
          events_array.push(type);
        } else if (name === "Usher") {
          events_array.push(type);
        } else if (name === "Assembler") {
          events_array.push(type);
        } else if (name === "Usher") {
          events_array.push(type);
        } else if (name === "Assembler") {
          industrial_array.push(type);
        } else if (name === "Fork Lift Operator") {
          industrial_array.push(type);
        } else if (name === "Laborer") {
          industrial_array.push(type);
          events_array.push(type);
        } else if (name === "Landscaper") {
          industrial_array.push(type);
        } else if (name === "Light Industrial") {
          industrial_array.push(type);
        } else if (name === "Material Handler") {
          industrial_array.push(type);
        } else if (name === "Mover/Packer") {
          industrial_array.push(type);
        } else if (name === "Night Shift") {
          other_array.push(type);
          industrial_array.push(type);
        } else if (name === "Picker/Packer") {
          industrial_array.push(type);
        } else if (name === "Shipping/Receiving") {
          industrial_array.push(type);
        } else if (name === "Skilled Trade") {
          industrial_array.push(type);
        } else if (name === "Stocker") {
          industrial_array.push(type);
          retail_array.push(type);
        } else if (name === "Warehouse") {
          events_array.push(type);
        } else if (name === "Admin/Clerical") {
          other_array.push(type);
        } else if (name === "Beta Tester") {
          other_array.push(type);
        } else if (name === "Call Center") {
          other_array.push(type);
        } else if (name === "Contractor") {
          other_array.push(type);
        } else if (name === "Customer Service") {
          other_array.push(type);
        } else if (name === "Interview session") {
          other_array.push(type);
        } else if (name === "Life Guard") {
          other_array.push(type);
        } else if (name === "Medical") {
          other_array.push(type);
        } else if (name === "Other") {
          other_array.push(type);
        } else if (name === "Part Time") {
          other_array.push(type);
        } else if (name === "Technical") {
          other_array.push(type);
        } else if (name === "Training") {
          other_array.push(type);
        } else if (name === "Videographer") {
          other_array.push(type);
        } else if (name === "Bartender") {
          rh_array.push(type);
        } else if (name === "Catering/Service Staff") {
          rh_array.push(type);
          events_array.push(type);
        } else if (name === "Dishwasher") {
          rh_array.push(type);
        } else if (name === "Facility Staff") {
          rh_array.push(type);
          industrial_array.push(type);
        } else if (name === "Food Service Staff") {
          rh_array.push(type);
        } else if (name === "Hospitality") {
          rh_array.push(type);
        } else if (name === "Host/Hostesses") {
          rh_array.push(type);
        } else if (name === "Housekeeping") {
          rh_array.push(type);
        } else if (name === "Janitorial Staff") {
          rh_array.push(type);
        } else if (name === "Line Cooks") {
          rh_array.push(type);
        } else if (name === "Restaurant Staff") {
          rh_array.push(type);
        } else if (name === "Runner") {
          rh_array.push(type);
        } else if (name === "Security") {
          rh_array.push(type);
          events_array.push(type);
          retail_array.push(type);
        } else if (name === "Servers") {
          rh_array.push(type);
        } else if (name === "Waiter/Waitress") {
          rh_array.push(type);
          events_array.push(type);
        } else if (name === "Cashier") {
          retail_array.push(type);
        } else if (name === "Retail Staff") {
          retail_array.push(type);
        } else if (name === "Seasonal Staff") {
          retail_array.push(type);
        } else if (name === "Trucking") {
          trans_array.push(type);
        } else if (name === "Delivery") {
          trans_array.push(type);
        } else if (name === "Driver") {
          trans_array.push(type);
        } else {
          if (name !== "Transportation" && name !== "Other" && name !== "Retail") {
            other_array.push(type);
          }
        }
      });
    } catch (err) {
      console.log("error processing jobs");
      //console.dir(err);
    } finally {
      categories.events = events_array;
      categories.light_industrial = industrial_array;
      categories.restaurant = rh_array;
      categories.retail = retail_array;
      categories.transportation = trans_array;
      categories.other = other_array;
      return categories;
    }
  }

  setPartnersPostsInteraction(job) {
    let payload = {};
    payload.interactionType = "CLICK_APPLY";
    payload.postId = job.id;
    payload.postUrl = job.partnerPostContent.url;
    payload.feedName = job.partnerPostContent.nameOfFeed;
    if (job.partnerPostContent.cpa) {
      payload.cpa = job.partnerPostContent.cpa;
    }
    if (job.partnerPostContent.cpc) {
      payload.cpc = job.partnerPostContent.cpc;
    }
    payload.jobCompany = job.partnerPostContent.company;
    payload.jobTitle = job.partnerPostContent.title;
    payload.jobCategory = job.partnerPostContent.category;
    payload.zipCode = job.partnerPostContent.zip;

    const logged_user = this.$localStorage.logged_user || {};

    let req = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/users/" + logged_user.id + "/partners-posts/interaction?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + logged_user.access_token,
      },
      data: payload,
    };

    return this.$http(req);
  }

  milesToKilometers(miles) {
    console.log("milesToKilometers");
    console.dir(miles);
    console.dir(miles * 1.60934);
    return miles * 1.60934;
  }

  kilometersToMiles(kilometers) {
    return kilometers * 0.621371;
  }

  processJob(job) {
    if (!job) return {error: null, job};

    if (job.partnerPostContent) {
      return this.processPartnerJob(job);
    } else {
      if (job.company) {
        job.companyName = job.company.name;

        if (_.isEmpty(job.company.fileCOMPANY_LOGO1IMG_160x160)) {
          job.companyLogo = "/app/vendor/images/events_placeholder_jobble.png";
        } else {
          job.companyLogo = job.company.fileCOMPANY_LOGO1IMG_160x160;
        }
      } else {
        if (job.subEvent.event.companyName) {
          job.companyName = job.subEvent.event.companyName;
        } else {
          job.companyName = job.subEvent.event.company.name;
          if (_.isEmpty(job.subEvent.event.company.companyLogoUriFree)) {
            job.companyLogo = "/app/vendor/images/events_placeholder_jobble.png";
          } else {
            job.companyLogo = job.subEvent.event.company.companyLogoUriFree;
          }
        }
      }

      job.jobbleTimeFrame = this.getJobbleTimeFrameWithTimeZoneForBoard(job);
      job.jobbleFullTimeFrame = this.getJobbleFullTimeFrameWithTimeZoneForBoard(job).date;
      job.jobbleHours = this.getJobbleFullTimeFrameWithTimeZoneForBoard(job).time;
      job.jobbleDuration = this.getJobbleFullTimeFrameWithTimeZoneForBoard(job).duration;
      job.rawDuration = this.getJobbleFullTimeFrameWithTimeZoneForBoard(job).rawDuration;

      job.applyTimeFrame = this.getApplyTimeFrame(job);

      let timeZone;
      if (job.contactInfo) {
        timeZone = job.contactInfo.place.timeZoneId;
      } else {
        timeZone = job.subEvent.contactInfo.place.timeZoneId;
      }

      if (timeZone === "Pacific/Honolulu") {
        job.startDate = new Date(job.startTime);
        job.endDate = new Date(job.endTime);
      } else {
        job.startDate = new Date(job.startTimeFormattedLoc);
        job.endDate = new Date(job.endTimeFormattedLoc);
      }

      let momentDateCreated = moment(job.dateCreated).format();
      //job.isHiredOrApplied = this.checkForApplicationStatus(job.applicationStatus);

      job.daysAgoPosted = Math.round((new Date() - new Date(momentDateCreated)) / (1000 * 60 * 60 * 24));
      job.numberofDays = Math.round((job.endDate - job.startDate) / (1000 * 60 * 60 * 24));

      job.daysAgoPostedText = job.daysAgoPosted === 0 ? "Today" : job.daysAgoPosted === 1 ? "Yesterday" : `${job.daysAgoPosted} days Ago`;

      return {error: null, job};
    }
  }

  checkForApplicationStatus(applicationStatus) {
    let status = "";

    if (applicationStatus === "PENDING") {
      status = "Applied";
    } else if (applicationStatus === "ACCEPTED") {
      status = "Hired";
    } else {
      status = null;
    }

    return status;
  }

  processPartnerJob(job) {
    if (!job) return {error: null, job};

    const regex = /^\s*(?:<br\s*\/?\s*>)+|(?:<br\s*\/?\s*>)+\s*$/gi;

    try {
      let partner_post_data = job.partnerPostContent;
      job.is_partner_post = true;
      job.companyName = partner_post_data.company;
      if (partner_post_data.companyLogo) {
        job.companyLogo = partner_post_data.companyLogo;
      } else {
        job.companyLogo = "/app/vendor/images/events_placeholder_jobble.png";
      }

      job.jobbleTypeName = job.jobbleType.name;

      job.eventName = partner_post_data.title;
      job.city = partner_post_data.city;
      job.state = partner_post_data.state;
      if (partner_post_data.posted_at) {
        job.date = partner_post_data.posted_at;
      } else if (partner_post_data.posted_date) {
        job.date = partner_post_data.posted_date;
      } else {
        job.date = moment().format();
      }

      job.url = partner_post_data.cm_url || partner_post_data.url;

      if (job.url && this.$location && this.$location.$$search) {
        const externalJPub = this.$location.$$search.jpub;

        const prefix = job.url.indexOf("?") !== -1 ? "&" : "?";

        if (externalJPub) {
          job.url = `${job.url}${prefix}&jparent=2`;
        } else {
          job.url = `${job.url}${prefix}`;
        }
      }

      job.daysAgoPosted = Math.round((new Date() - new Date(job.date)) / (1000 * 60 * 60 * 24));

      job.daysAgoPostedText = job.daysAgoPosted === 0 ? "Today" : job.daysAgoPosted === 1 ? "Yesterday" : `${job.daysAgoPosted} days Ago`;

      // Check to see if there is HTML in the partner post description by matching tags
      if (/<[a-z][\s\S]*>/i.test(partner_post_data.body) === false) {
        job.job_details_no_html = partner_post_data.body;
        job.no_html_desc = true;
      } else {
        partner_post_data.body = partner_post_data.body.replace(regex, "");
        job.job_parsed_html = partner_post_data.body;
      }

      return {error: null, job};
    } catch (err) {
      return {error: err, job};
    }
  }

  awaitForGoogleToLoad() {
    let count = 0;
    return new Promise((resolve, reject) => {
      if (!angular.isUndefined(window.google)) return resolve();

      this.googleLoad = this.$interval(() => {
        count = count = 1;
        console.warn("Trying to load google", count);
        if (!angular.isUndefined(window.google) || count > 5) {
          resolve();
          this.$interval.cancel(this.googleLoad);
          this.googleLoad = undefined;
        }
      }, 500);
    });
  }
}

JobService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "env", "$rootScope", "$timeout", "$interval", "$location"];



// WEBPACK FOOTER //
// ./client/app/services/jobs.js